// extracted by mini-css-extract-plugin
export default {"wrapper":"_7a386ed","titles":"_9992612d","title":"_63f66c1e"};